export default "__VITE_ASSET__567DSb1h__"